"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = __importDefault(require("../providers/api"));
var utils_1 = require("../utils");
exports.AuthApiAdapter = function (baseUrl, apiProvider) {
    if (apiProvider === void 0) { apiProvider = new api_1.default(); }
    return {
        login: function (identifier, password) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, apiProvider.post(baseUrl + '/oauth/token', {
                        body: {
                            identifier: identifier,
                            password: password,
                            grant_type: 'password'
                        },
                    })
                        .then(function (result) {
                        var session = result.data.body;
                        return utils_1.mapObjectKeys({
                            access_token: 'accessToken',
                            refresh_token: 'refreshToken',
                        }, session);
                    })];
            });
        }); },
        refreshToken: function (refreshToken) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, apiProvider.post(baseUrl + '/oauth/token', {
                        body: {
                            grant_type: 'token',
                            refreshToken: refreshToken
                        }
                    })
                        .then(function (result) {
                        var session = result.data.body;
                        return utils_1.mapObjectKeys({
                            access_token: 'accessToken',
                            refresh_token: 'refreshToken',
                        }, session);
                    })];
            });
        }); },
        me: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, apiProvider.get(baseUrl + '/me')
                        .then(function (result) { return result.data.body; })];
            });
        }); },
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aGVudGljYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWRhcHRlcnMvYXV0aGVudGljYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaUJBa0RBOztBQWhEQSx5REFBMkM7QUFDM0Msa0NBQXlDO0FBUTVCLFFBQUEsY0FBYyxHQUFHLFVBQUMsT0FBZSxFQUFFLFdBQStCO0lBQS9CLDRCQUFBLEVBQUEsa0JBQWtCLGFBQVcsRUFBRTtJQUM3RSxPQUFvQjtRQUNsQixLQUFLLEVBQUUsVUFBTyxVQUFrQixFQUFFLFFBQWdCOztnQkFDaEQsc0JBQU8sV0FBVyxDQUFDLElBQUksQ0FBQyxPQUFPLEdBQUcsY0FBYyxFQUFFO3dCQUNoRCxJQUFJLEVBQUU7NEJBQ0osVUFBVSxZQUFBOzRCQUNWLFFBQVEsVUFBQTs0QkFDUixVQUFVLEVBQUUsVUFBVTt5QkFDdkI7cUJBQ0YsQ0FBQzt5QkFDQyxJQUFJLENBQUMsVUFBQyxNQUFXO3dCQUNoQixJQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQzt3QkFDakMsT0FBTyxxQkFBYSxDQUFDOzRCQUNuQixZQUFZLEVBQUUsYUFBYTs0QkFDM0IsYUFBYSxFQUFFLGNBQWM7eUJBQzlCLEVBQUUsT0FBTyxDQUFZLENBQUM7b0JBQ3pCLENBQUMsQ0FBQyxFQUFDOzthQUNOO1FBQ0QsWUFBWSxFQUFFLFVBQU8sWUFBb0I7O2dCQUN2QyxzQkFBTyxXQUFXLENBQUMsSUFBSSxDQUFDLE9BQU8sR0FBRyxjQUFjLEVBQUU7d0JBQ2hELElBQUksRUFBRTs0QkFDSixVQUFVLEVBQUUsT0FBTzs0QkFDbkIsWUFBWSxjQUFBO3lCQUNiO3FCQUNGLENBQUM7eUJBQ0MsSUFBSSxDQUFDLFVBQUMsTUFBVzt3QkFDaEIsSUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7d0JBQ2pDLE9BQU8scUJBQWEsQ0FBQzs0QkFDbkIsWUFBWSxFQUFFLGFBQWE7NEJBQzNCLGFBQWEsRUFBRSxjQUFjO3lCQUM5QixFQUFFLE9BQU8sQ0FBWSxDQUFDO29CQUN6QixDQUFDLENBQUMsRUFBQzs7YUFDTjtRQUNELEVBQUUsRUFBRTs7Z0JBQ0Ysc0JBQU8sV0FBVyxDQUFDLEdBQUcsQ0FBQyxPQUFPLEdBQUcsS0FBSyxDQUFDO3lCQUNwQyxJQUFJLENBQUMsVUFBQyxNQUFXLElBQUssT0FBQSxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksRUFBaEIsQ0FBZ0IsQ0FBQyxFQUFDOzthQUM1QztLQUNGLENBQUM7QUFDSixDQUFDLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ../@core/dist/adapters/authentication.js
// module id = 883
// module chunks = 0